<div class="row">
    <div class="col-12">
        <div class="alert alert-info">
            <p>Download a CSV of the selected types of people and organisations.</p>
        </div>

        <h3>The types of <b>people</b> you want to export</h3>
        <dx-check-box [(value)]="includeOrgLeaders"
                      text="Organisation leaders"
                      class="mb-2 d-block"></dx-check-box>
        <dx-check-box [(value)]="includeTeamLeaders"
                      text="Team leaders"
                      class="mb-2 d-block"></dx-check-box>
        <dx-check-box [(value)]="includeFunctionLeaders"
                      text="Function leaders"
                      class="mb-2 d-block"></dx-check-box>
        <dx-check-box [(value)]="includeCulturalLeaders"
                      text="Cultural leaders"
                      class="mb-2 d-block"></dx-check-box>
        <dx-check-box [(value)]="includeOwners"
                      text="Owners"
                      class="mb-2 d-block"></dx-check-box>

        <h3 class="mt-4">The types of <b>organisations</b> you want to export</h3>
        <dx-check-box [value]="true"
                      [disabled]="true"
                      text="Coached by us or coach partners"
                      class="mb-2 d-block"></dx-check-box>
        <dx-check-box [(value)]="includeStrategicPartnerCoachedOrganisations"
                      text="Coached by strategic partners"
                      class="mb-2 d-block"></dx-check-box>

        <button class="mt-3 btn btn-primary"
                [adaptBlockingClick]="generateList">Generate CSV!</button>
        @if (result) {
            <div class="mt-3 alert alert-light">{{ result }}</div>
        }
    </div>
</div>
